export default "__VITE_ASSET__DcPIYdY4__"